import type { StatusTone } from '@vnetwork/ui/data';
import {
  TICKET_STATUS_OPENING,
  TICKET_STATUS_WORK_IN_PROGRESS,
  TICKET_STATUS_COMPLETED,
  TICKET_STATUS_CLOSED,
  TICKET_STATUS_ESCALATED,
  TICKET_STATUS_LABEL,
} from '@/api/tickets-constants';

/** Ticket status → StatusPill tone. */
export function ticketStatusTone(status?: string): StatusTone {
  switch (status) {
    case TICKET_STATUS_OPENING:
      return 'info';
    case TICKET_STATUS_WORK_IN_PROGRESS:
      return 'warning';
    case TICKET_STATUS_ESCALATED:
      return 'danger';
    case TICKET_STATUS_COMPLETED:
      return 'success';
    case TICKET_STATUS_CLOSED:
      return 'neutral';
    default:
      return 'neutral';
  }
}

/** Ticket status → human display label (EN). */
export function ticketStatusLabel(status?: string): string {
  if (!status) return '—';
  return TICKET_STATUS_LABEL[status] ?? status.replace(/-/g, ' ').toUpperCase();
}

/** Ticket priority → StatusPill tone. Legacy vocab: low/medium/high only. */
export function ticketPriorityTone(priority?: string): StatusTone {
  switch (priority?.toLowerCase()) {
    case 'high':
      return 'warning';
    case 'medium':
      return 'info';
    case 'low':
      return 'neutral';
    default:
      return 'neutral';
  }
}
